import type { PatchGraphV1 } from '../../packages/routing-graph/src/index.js';
/** Separate opt-in example. Never rewrites the original fixed-host/v1 preset. */
export function liveGraphExample():PatchGraphV1{return {
 schemaVersion:1,id:'allmost-live-dag-example',seed:1,
 nodes:[
  {id:'osc',moduleId:'mir.mod-001',parameters:{frequency:110,waveform:1},position:{x:20,y:20}},
  {id:'lfo',moduleId:'mir.mod-015',parameters:{'rate-hz':.7},position:{x:20,y:330}},
  {id:'note-map',moduleId:'mir.host-control',parameters:{base:66,depth:12},position:{x:350,y:330}},
  {id:'filter',moduleId:'mir.mod-019',parameters:{'cutoff-hz':900,'key-track':1,q:1.2},position:{x:680,y:20}},
  {id:'amp',moduleId:'mir.host-vca',parameters:{gain:.3},position:{x:1010,y:20}},
  {id:'phaser',moduleId:'mir.mod-029',parameters:{mix:.5},position:{x:1340,y:20}},
 ],
 connections:[
  {id:'osc-filter',source:{nodeId:'osc',portId:'out'},target:{nodeId:'filter',portId:'in'}},
  {id:'filter-amp',source:{nodeId:'filter',portId:'out'},target:{nodeId:'amp',portId:'in'}},
  {id:'amp-phaser',source:{nodeId:'amp',portId:'out'},target:{nodeId:'phaser',portId:'in'}},
  {id:'lfo-map',source:{nodeId:'lfo',portId:'out'},target:{nodeId:'note-map',portId:'in'}},
  {id:'map-filter',source:{nodeId:'note-map',portId:'out'},target:{nodeId:'filter',portId:'note'}},
 ],
};}
